"use client";

export type ReminderStatus = "OPEN" | "COMPLETED" | "DISMISSED";

// Keep this extensible; backend may add sources over time.
export type ReminderSource =
  | "MANUAL"
  | "SYSTEM"
  | (string & Record<never, never>);

/** A point-in-time (or all-day) reminder vs. a start/end appointment. */
export type ReminderKind = "REMINDER" | "APPOINTMENT";

export const REMINDER_COLORS = [
  "sky",
  "amber",
  "violet",
  "rose",
  "emerald",
  "orange"
] as const;
export type ReminderColor = (typeof REMINDER_COLORS)[number];

export type ForeignNationalReminder = {
  reminder_id: string;
  foreign_national_id: string;

  law_firm_id?: string | null;
  practice_name?: string | null;

  title: string;
  description?: string | null;
  /** Due instant for reminders; start instant for appointments. */
  due_date: string;

  /** Calendar fields; older records may omit them (treat as a plain reminder). */
  kind?: ReminderKind | null;
  end_date?: string | null;
  all_day?: boolean | null;
  location?: string | null;
  color?: ReminderColor | string | null;
  /** Appointments only: shown under "Coming up" in the client's portal. */
  shared_with_client?: boolean | null;

  status: ReminderStatus;
  completed_at?: string | null;
  dismissed_at?: string | null;

  assigned_to_user_ids: string[];

  source: ReminderSource;
  system_rule_id?: string | null;
  system_subject_id?: string | null;
  system_key?: string | null;
  system_managed: boolean;
};

export type CreateForeignNationalReminderRequest = {
  title: string;
  description?: string | null;
  due_date: string;
  assigned_to_user_ids?: string[] | null;
  kind?: ReminderKind;
  end_date?: string | null;
  all_day?: boolean;
  location?: string | null;
  color?: ReminderColor | null;
  shared_with_client?: boolean | null;
};

export type UpdateForeignNationalReminderRequest = {
  title?: string | null;
  description?: string | null;
  due_date?: string | null;
  assigned_to_user_ids?: string[] | null;
  status?: ReminderStatus | null;
  completed_at?: string | null;
  dismissed_at?: string | null;
  kind?: ReminderKind | null;
  end_date?: string | null;
  all_day?: boolean | null;
  location?: string | null;
  color?: ReminderColor | null;
  shared_with_client?: boolean | null;
};
